import { connect } from 'react-redux';

import { setGlobalError } from '@/store/reducers/global/actions';
import { clearLegacyUserInfo, setLegacyUserInfo } from '@/store/reducers/user/actions';

import AuthProvider from './authProvider';

const mapActionsToProps = {
  clearLegacyUserInfo,
  setGlobalError,
  setLegacyUserInfo,
};

export { AuthContext, useAuth } from './useAuth';

export default connect(undefined, mapActionsToProps)(AuthProvider);
